"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var IDBack = function IDBack(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "account",
    viewBox: "0 0 48 32"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    id: "Onboarding-03---KYC-4",
    transform: "translate(-880.000000, -374.000000)",
    fill: "currentColor"
  }, react_1["default"].createElement("g", {
    transform: "translate(320.000000, 152.000000)"
  }, react_1["default"].createElement("g", {
    transform: "translate(416.000000, 190.000000)"
  }, react_1["default"].createElement("path", {
    d: "M188,32 C190.209139,32 192,33.790861 192,36 L192,60 C192,62.209139 190.209139,64 188,64 L148,64 C145.790861,64 144,62.209139 144,60 L144,36 C144,33.790861 145.790861,32 148,32 L188,32 Z M146,46 L146,60 C146,61.0543618 146.815878,61.9181651 147.850738,61.9945143 L148,62 L188,62 C189.054362,62 189.918165,61.1841222 189.994514,60.1492623 L190,60 L190,46 L146,46 Z M146,40 L190,40 L190,36 C190,34.8954305 189.104569,34 188,34 L148,34 C146.945638,34 146.081835,34.8158778 146.005486,35.8507377 L146,36 L146,40 Z"
  }))))));
};

exports["default"] = IDBack;